export const orange = "#ff6600";
export const green = "#009900";
export const blue = "#0066cc";
export const violet = "#660066";
export const yellow = "#ffcc00";
